import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SendNotificationPage from "views/admin/notifications";

const CenterSendNotifications = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <SendNotificationPage centerId={centerId} />;
};

export default CenterSendNotifications;
